import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-alpha-nav",
  templateUrl: "./alpha-nav.component.html",
})
export class AlphaNavComponent {
  // Currently selected value ("all" or a single letter). Drives the
  // 'font-weight-bold' class on the matching link, identical to the
  // previous inline markup which read the parent's `alphaVal`.
  @Input() public alphaVal: string = "all";

  // Re-emits the clicked value ('all','A'..'Z'). Each parent wires this to
  // its own alphaSearch($event), preserving the original handler + arg.
  @Output() public letterClick = new EventEmitter<string>();

  // Letters rendered after the "All" link, in original A..Z order.
  public letters: string[] = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  public onLetterClick(value: string): void {
    this.letterClick.emit(value);
  }
}
